import React from "react";
import { useTranslation } from "react-i18next";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import Button from "app/components/Button/ButtonVariant";
import styles from "./styles.module.scss";

interface Props {
  isOpen: boolean;
  memberName: string;
  onClose: () => void;
}

// Success popup shown after a family member is added (CFTB-3274), replacing the
// previous toast. Check-above-centered-title layout with a full-width primary
// confirm, per design.
const FamilyMemberAddedModal = ({ isOpen, memberName, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={onClose}
      classNames={styles.popup}
      centerVertically
    >
      <div className={styles.content}>
        <i className={`ico ico-check ${styles.check}`} />
        <h2 className={styles.title}>{t("Family Member Added")}</h2>
        <p className={styles.message}>
          {t('You have successfully added "{{name}}" as a family member.', {
            name: memberName,
          })}
        </p>
        <Button
          buttonType="primary"
          title={t("Ok")}
          buttonStyles={styles.ok_button}
          onClickFunc={onClose}
        />
      </div>
    </ModalLayout>
  );
};

export default FamilyMemberAddedModal;
